import React, {FC, useEffect, useState} from "react";
import {Flex, Layout} from "antd";
import Sidebar from "../Sidebar";
import SBHeader from "./SBHeader";
import SBFooter from "./SBFooter";
import {contentStyle, footerStyle, headerStyle, layoutStyle, siderStyle} from "./SBStyles";
import SBRoutes from "./SBRoutes";
import AxiosServices from "../../Services/axiosServices";
import {useGlobal} from "../../config/GlobalContext";
import {useAuth} from "../../config/AuthContext";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store";
import {fetchUserBets} from "../betsSlice";
import ChatRequestNotifier from "../Chat/ChatRequestNotifier";
import CompetitionBetsReminder from "../CompetitionBetsReminder";

const {Header, Content, Footer, Sider} = Layout;

const SBLayout: FC = () => {

    const {setGroups, currentCmpEdt} = useGlobal();
    const {isLoggedIn, authUser} = useAuth();
    const dispatch = useDispatch<AppDispatch>();
    const [collapsed, setCollapsed] = useState(false);

    useEffect(() => {
        if (currentCmpEdt === 0) return;
        AxiosServices.getGroups(setGroups, currentCmpEdt)
            .then()
            .catch(err => console.error(err));
    }, [setGroups, currentCmpEdt]);

    useEffect(() => {
        if (!isLoggedIn || !authUser?.username || !currentCmpEdt) return;
        dispatch(fetchUserBets({competition: currentCmpEdt, usr: authUser.username}));
    }, [isLoggedIn, authUser?.username, dispatch, currentCmpEdt]);

    return (
        <Flex gap="middle" wrap>
            <Layout hasSider={true} style={layoutStyle}>
                {!collapsed &&
                    <Sider width="15rem" style={siderStyle}>
                        <Sidebar/>
                    </Sider>
                }
                <Layout>
                    <Header style={headerStyle}>
                        <SBHeader collapsed={collapsed} setCollapsed={setCollapsed}/>
                    </Header>
                    <Content style={contentStyle}>
                        <SBRoutes/>
                    </Content>
                    <Footer style={footerStyle}>
                        <SBFooter/>
                    </Footer>
                </Layout>
            </Layout>
            <ChatRequestNotifier/>
            <CompetitionBetsReminder/>
        </Flex>
    );
}

export default SBLayout;
